import type { LegacyLanguage } from '../gateway/contracts';

export const LEGACY_LANGUAGE_STORAGE_KEY = 'nordrevived.language.v1';

const LANGUAGE_ALIASES: Readonly<Record<string, LegacyLanguage>> = {
  sv: 'swedish',
  swe: 'swedish',
  swedish: 'swedish',
  en: 'english',
  eng: 'english',
  english: 'english',
  da: 'danish',
  dan: 'danish',
  danish: 'danish',
  no: 'norwegian',
  nb: 'norwegian',
  nn: 'norwegian',
  nor: 'norwegian',
  norwegian: 'norwegian',
};

export function legacyLanguageFromSearch(search: string): LegacyLanguage {
  const requested = new URLSearchParams(search).get('language')?.trim().toLowerCase();
  return requested === undefined ? 'english' : (LANGUAGE_ALIASES[requested] ?? 'english');
}

export function loadLegacyLanguage(
  search: string,
  storage: Pick<Storage, 'getItem'> = localStorage,
): LegacyLanguage {
  try {
    const stored = storage.getItem(LEGACY_LANGUAGE_STORAGE_KEY)?.trim().toLowerCase();
    if (stored !== undefined && LANGUAGE_ALIASES[stored] !== undefined) {
      return LANGUAGE_ALIASES[stored];
    }
  } catch {
    // Fall back to the launch URL when browser storage is unavailable.
  }
  return legacyLanguageFromSearch(search);
}

export function saveLegacyLanguage(
  language: LegacyLanguage,
  storage: Pick<Storage, 'setItem'> = localStorage,
): void {
  storage.setItem(LEGACY_LANGUAGE_STORAGE_KEY, language);
}

export function legacyLanguageHtmlTag(language: LegacyLanguage): string {
  switch (language) {
    case 'swedish':
      return 'sv';
    case 'english':
      return 'en';
    case 'danish':
      return 'da';
    case 'norwegian':
      return 'no';
  }
}
